import React, { useState } from "react";

// import { matchPath, useLocation } from "react-router-dom";

import CloseIcon from "@mui/icons-material/Close";
// import ForwardToInboxIcon from "@mui/icons-material/ForwardToInbox";
import { Box, Button, Divider, IconButton, Stack, Tab, Tabs, Typography } from "@mui/material";
import { AsyncContent } from "components/Async-content/AsyncContent";
import { RichTextEditor } from "components/forms/Rich-text-editor/RichTextEditor";
// import { SelectAutocomplete } from "components/forms/Select-autocomplete/Select-autocomplete";
// import { useTaskDealsSelect } from "store";
import { DocumentMeeting } from "store/types";

import { MeetingHeader } from "./MeetingHeader";
import { TxtReader } from "./TxtReader";

interface Props {
  onCancel: () => void;
  meeting: DocumentMeeting;
  documentId?: number;
  sectionId?: number;
  defaultTab?: "Summary" | "Transcription";
}

export const MeetingViewerContent: React.FC<Props> = ({ onCancel, meeting, documentId, sectionId, defaultTab }) => {
  // const deals = useTaskDealsSelect();

  const [currentTab, setCurrentTab] = useState<"Summary" | "Transcription">(defaultTab || "Summary");

  return (
    <Stack
      sx={{
        ...style,
        display: "flex",
        flexDirection: "column",
        width: 900,
        p: "32px",
        borderRadius: "8px",
        bgcolor: "white",
        boxShadow:
          "0px 2px 4px -1px rgba(0, 0, 0, 0.20), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)"
      }}
    >
      <AsyncContent loading={!meeting}>
        <Stack gap="24px">
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{ borderBottom: "1px solid #DAE0E2" }}
          >
            <Typography>Meeting transcription</Typography>
            <IconButton onClick={onCancel}>
              <CloseIcon className="icon" />
            </IconButton>
          </Stack>

          <MeetingHeader meeting={meeting} documentId={documentId} sectionId={sectionId} menuAvailable={false} />
          <TableTabs currentTab={currentTab} setCurrentTab={setCurrentTab} />

          <Stack
            gap="15px"
            sx={{
              overflow: "auto",
              height: "400px",
              borderBottom: "1px solid #DAE0E2",
              ".e-disabled": { opacity: 1 },
              ".e-content": { color: "#071F35 !important" }
            }}
          >
            {currentTab === "Summary" ? (
              <RichTextEditor
                id={"meeting-" + meeting?.id}
                saveInterval={1}
                value={meeting?.description || ""}
                enabled={false}
                inlineMode={{
                  enable: true,
                  onSelection: true
                }}
              />
            ) : (
              meeting?.transcription && <TxtReader file_url={meeting.transcription} />
            )}
          </Stack>

          {/* {!isMeetingInbox ? ( */}
          <Stack direction="row" gap="10px" justifyContent="flex-end">
            <Button onClick={onCancel} variant="contained" sx={{ backgroundColor: "#071F35", minWidth: "70px" }}>
              Ok
            </Button>
          </Stack>
          {/* ) : (
            <Stack direction="row" gap="10px" justifyContent="space-between" alignItems="center">
              <SelectAutocomplete
                options={deals}
                multiple
                renderOption={(props, option) => <li {...props}>{option.title}</li>}
                getOptionLabel={(option) => option.title}
                compareParam={(option) => option.title}
                renderInput={(params) => <TextField sx={{ width: "300px" }} {...params} label="Deals" />}
                disableCloseOnSelect
              />
              <Stack gap="10px" direction="row" alignItems="center">
                <Button onClick={onCancel} variant="outlined">
                  Close
                </Button>
                <Button startIcon={<ForwardToInboxIcon sx={{ fontSize: 20 }} />} onClick={onCancel} variant="contained">
                  Move
                </Button>
              </Stack>
            </Stack>
          )} */}
        </Stack>
      </AsyncContent>
    </Stack>
  );
};

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  borderRadius: "10px"
};

interface TabsProps {
  currentTab: "Summary" | "Transcription";
  setCurrentTab: (tab: "Summary" | "Transcription") => void;
}

const TableTabs: React.FC<TabsProps> = ({ currentTab, setCurrentTab }) => {
  const handleChange = (event: React.SyntheticEvent, newValue: "Summary" | "Transcription") => {
    setCurrentTab(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box>
        <Tabs
          value={currentTab}
          onChange={handleChange}
          sx={{
            minHeight: "auto",
            ".MuiTabs-flexContainer": {
              gap: "16px",
              alignItems: "center"
            },

            ".MuiTabs-indicator": {
              bgcolor: "#071F35"
            },

            ".MuiTab-root": {
              padding: "2px 0 6px 0",
              minHeight: 24,
              minWidth: "auto",
              color: "#496682",
              "&.Mui-selected": {
                color: "#071F35"
              }
            }
          }}
        >
          <Tab value="Summary" label="Summary" />
          <Divider orientation="vertical" sx={{ width: "1px", height: 18, borderColor: "#DBE8F5" }} />
          <Tab value="Transcription" label="Transcription" />
        </Tabs>
      </Box>
    </Box>
  );
};
